import styled from 'styled-components';
import {
  Image,
  Dropdown as SemanticDropdown,
  Icon as SemanticIcon,
} from 'semantic-ui-react';

import { Segment as SegmentLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const TaskSegment = styled(SegmentLayoutComponent)`
  &&& {
    background: ${(props) => props.theme.color.segmentCreateProjectBackground};
    padding: 20px;
    margin: ${(props) => (props.isEdit ? '20px 0' : '0')};
    width: 100%;
  }
`;

const ActionLink = styled.a`
  float: right;
  margin-right: 25px;
`;

const Dropdown = styled(SemanticDropdown)`
&&& {
  margin-top: 15px;
  &&:hover {
    background: ${(props) => props.theme.color.whtite};
  }
  &.active {
    background: ${(props) => props.theme.color.whtite};
  }
  &.ui.dropdown>.dropdown.icon{
    display: none;
  }
}
`;

const ComingSoon = styled.span`
  background: #c1ff9d;
  border-radius: 5px;
  color: ${({ theme }) => theme.color.buttonInvertedText};
  margin-left: 5px;
  padding: 5px;
  font-size: 10px;
`;

const DropdownColumn = styled.div`
`;

const DropdownMenu = styled(SemanticDropdown.Menu)`
  &&&{
    margin-top: 15px;
  }

  &&&.menu>div {
    display: flex;
    flex-direction: row;
  }

  &&&.menu>div>div>.header {
    position: relative;
    cursor: pointer;
    display: block;
    border: none;
    height: auto;
    text-align: left;
    border-top: none;
    line-height: 1em;
    color: rgba(0,0,0,.87);
    padding: 0.78571429rem 1.14285714rem!important;
    font-size: 1rem;
    text-transform: none;
    font-weight: 400;
    box-shadow: none;
    -webkit-touch-callout: none;
  }

  &&&.menu>div>div>.item {
    position: relative;
    cursor: pointer;
    display: block;
    border: none;
    height: auto;
    text-align: left;
    border-top: none;
    line-height: 1em;
    color: rgba(0,0,0,.87);
    padding: 0.78571429rem 1.14285714rem!important;
    font-size: 1rem;
    text-transform: none;
    font-weight: 400;
    box-shadow: none;
    -webkit-touch-callout: none;
  }

  &&&.menu>div>div>.item:hover {
    background: rgba(0,0,0,.05);
    color: rgba(0,0,0,.95);
    z-index: 13;
  }

  &&&.menu>div>div>div>.item {
    position: relative;
    cursor: pointer;
    display: block;
    border: none;
    height: auto;
    text-align: left;
    border-top: none;
    line-height: 1em;
    color: rgba(0,0,0,.87);
    padding: 0.78571429rem 1.14285714rem!important;
    font-size: 1rem;
    text-transform: none;
    font-weight: 400;
    box-shadow: none;
    -webkit-touch-callout: none;
    pointer-events: none,
  }

  &&&.menu>div>div>div>.item:hover {
    background: rgba(0,0,0,.05);
    color: rgba(0,0,0,.95);
    z-index: 13;
  }
`;

const IconItem = styled(Image)`
  &&& {
    height: 20px;
    width: 20px;
    margin-right: 10px;
  }
`;

const CircleItem = styled.div`
  width: ${({ small }) => (small ? '25px' : '30px')};
  height: ${({ small }) => (small ? '25px' : '30px')};
  border-radius: 15px;
  display: flex;
  background-color: blue;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
`;

const Icon = styled(SemanticIcon)`
  &&&{
    ${({ small }) => small && 'font-size: 12px;'};
    margin: 0;
    height: fit-content;
    width: fit-content;
    color: ${(props) => props.theme.color.white};
  }
`;

const EmptyIcon = styled.div`
  height: 20px;
  width: 20px;
  background-color: #dddddd;
  border-radius: 2px;
  margin-right: 10px;
`;

const ContainerItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const ItemText = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.multipleDropdown};
`;

const HeaderText = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.multipleDropdown};
  text-transform: none;
  font-weight: 500;
`;

const ContainerAddQuestion = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const TextAddQuestion = styled(TextLayoutComponent)`
  font-size: ${({ small }) => (small ? '14px' : '16px')};
  font-weight: 500;
`;

const ContainerDropdown = styled.div`
  display: flex;
  justify-content: ${(props) => (props.right ? 'flex-end' : 'space-between')};
`;

export {
  ActionLink,
  Dropdown,
  DropdownMenu,
  DropdownColumn,
  ContainerAddQuestion,
  TaskSegment,
  TextAddQuestion,
  IconItem,
  ContainerItem,
  EmptyIcon,
  CircleItem,
  Icon,
  ItemText,
  HeaderText,
  ContainerDropdown,
  ComingSoon,
};
